import { OnsipAPIBoolean, onsipApiBooleanToBoolean } from "../../apiResponse/xml-json";

export declare interface ApiGatewayUser {
  CallerId: string;
  CallerIdName: string;
  CallerIdNumber: string;
  Created: string;
  DtmfMode: string;
  Modified: string;
  Nat: string;
  OriginationIp: string;
  OriginationPort: string;
  Password: string;
  TerminationIp: string;
  TerminationPasswordEnabled: OnsipAPIBoolean;
  UserId: string;
  Username: string;
}

export declare interface GatewayUser {
  callerId: string;
  callerIdName: string;
  callerIdNumber: string;
  dtmfMode: string;
  nat: string;
  originationIp: string;
  originationPort: string;
  password: string;
  terminationIp: string;
  terminationPasswordEnabled: boolean;
  userId: string;
  username: string;
}

export function ApiGateUsertoGatewayUser(apiGatewayUser: ApiGatewayUser): GatewayUser {
  return {
    callerId: apiGatewayUser.CallerId,
    callerIdName: apiGatewayUser.CallerIdName,
    callerIdNumber: apiGatewayUser.CallerIdNumber,
    dtmfMode: apiGatewayUser.DtmfMode,
    nat: apiGatewayUser.Nat,
    originationIp: apiGatewayUser.OriginationIp,
    originationPort: apiGatewayUser.OriginationPort,
    password: apiGatewayUser.Password,
    terminationIp: apiGatewayUser.TerminationIp,
    terminationPasswordEnabled: onsipApiBooleanToBoolean(apiGatewayUser.TerminationPasswordEnabled),
    userId: apiGatewayUser.UserId,
    username: apiGatewayUser.Username
  };
}
